import React from 'react';
import { acceptanceCreationSteps } from '../../../../model';
import AddressesSetup from './AddressesSetup';
import AcceptanceSetup from './AcceptanceSetup';
import styles from './index.module.scss';

const bodies = {
  [acceptanceCreationSteps.addressesSetup]: AddressesSetup,
  [acceptanceCreationSteps.acceptanceSetup]: AcceptanceSetup,
};

const Body = ({ step }) => {
  const Component = bodies[step];
  return <Component className={styles.root} />;
};

export default Body;
